import React from "react"

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: string | number
  color?: string
  title?: string
}

export const MdInfoOutline: React.FC<IconProps> = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 24 24"
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {title && <title>{title}</title>}
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    </svg>
  )
}

export default MdInfoOutline
